import { Injectable } from '@angular/core';
import { StudyFile } from '../models/Study/study-file.model';
import { SpinnerService } from '../shared-new/services/spinner.service';
import { Study } from '../models/Study/study.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StudyFilesDownloaderComponent } from '../clinic-studies/edit-clinical-study-profile/components/study-files-downloader/study-files-downloader.component';

@Injectable({
  providedIn: 'root',
})

export class DownloadUtilsService {
  constructor(private spinnerService: SpinnerService, private modalService: NgbModal) { }

  public async triggerFileDownload(url: string, fileName: string) {
    const downloadActionKey = `downloadStudyFile_${url}_${Math.random() * 1000000}`;
    try {

      this.spinnerService.addRequest(downloadActionKey);
      const response = await fetch(url);
      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = blobUrl;
      anchor.download = fileName;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);

      window.URL.revokeObjectURL(blobUrl);
      this.spinnerService.popRequest(downloadActionKey);
    } catch (error) {
      this.spinnerService.popRequest(downloadActionKey);
      console.error('Error downloading file:', error);
    }
  }

  public async triggerDownloaderPopup(study: Study, dicomFiles: StudyFile[], reportFiles: StudyFile[], scopeFiles: StudyFile[], mode: string, protectedString?: string) {
    const modalRef = this.modalService.open(StudyFilesDownloaderComponent, {
      size: 'md',
      centered: true,
      keyboard: false,
      backdrop: 'static',
    });

    const allDicomSizeInBytes: number | null =
      dicomFiles.some(a => a.studyFileSizeInBytes === null) ? null :
        dicomFiles.reduce((sum, file) => sum + (file.studyFileSizeInBytes || 0), 0);

    const allJpegSizeInBytes: number | null =
      dicomFiles.some(a => a.previewFileSizeInBytes === null) ? null :
        dicomFiles.reduce((sum, file) => sum + (file.previewFileSizeInBytes || 0), 0);

    modalRef.componentInstance.studyId = study?.studyId;
    modalRef.componentInstance.fileInfo = {
      studyFileIds: dicomFiles.map(a => a.studyFileId),
      xrayCount: dicomFiles.length,
      reportFiles: reportFiles,
      scopeFiles: scopeFiles,
      studyId: study?.studyId,
      saleId: study?.saleId,
      horseId: study?.horseId,
      allDicomSizeInBytes: allDicomSizeInBytes,
      allJpegSizeInBytes: allJpegSizeInBytes,
      mode: mode,
      protectedString: protectedString
    };
    modalRef.closed.subscribe((res) => {
      // console.log(res);
    });
  }
}
